/**
 * Temporary company-based hide for milk yield / lactation UI.
 * Arbor = 10, Valiev = 14 — no dairy integration.
 * TODO: replace with a proper system-wide flag later.
 */
const COMPANIES_WITHOUT_MILK_UI = new Set([10, 14])

export const isCompanyWithoutMilkUi = (companyId?: number | null): boolean =>
	companyId != null && COMPANIES_WITHOUT_MILK_UI.has(companyId)

export const showMilkYieldUi = (companyId?: number | null): boolean =>
	!isCompanyWithoutMilkUi(companyId)

export const showMilkYieldData = (
	companyId?: number | null,
	dairyIntegration?: string | null,
): boolean => Boolean(dairyIntegration) && showMilkYieldUi(companyId)

/** Dashboard widget types that belong to milk yield / lactation UI. */
export const MILK_YIELD_WIDGET_TYPES = new Set([
	'ACTUAL_YIELD',
	'REJECTED_MILK_YIELD',
	'AVG_MILK_YIELD',
	'MILK_YIELD_LINEAR_CHART',
])

export const isMilkYieldWidgetType = (type: string): boolean =>
	MILK_YIELD_WIDGET_TYPES.has(type)
